function _objectDestructuringEmpty(obj) {if (obj == null) throw new TypeError("Cannot destructure " + obj);}function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Translate } from "../../I18N";
import { CurrentLocationLink } from "../../Layout";
import { searchParamsFromSearchParams } from "../../utils/routeHelpers";

const disableButton = (page, pageToDisable) => ({
  className: page === pageToDisable ? 'btn disabled' : 'btn',
  rel: page === pageToDisable ? 'nofollow' : undefined
});

const Paginator = ({ page, totalPages, onPageChange }) => {
  const prevPage = page - 1 || 1;
  const nextPage = page + 1 > totalPages ? totalPages : page + 1;
  return /*#__PURE__*/(
    _jsx("div", { className: "paginator" }, void 0, /*#__PURE__*/
    React.createElement(CurrentLocationLink, _extends({
      queryParams: { page: prevPage },
      onClick: (e) => {
        e.preventDefault();
        onPageChange(prevPage);
      } },
    disableButton(page, 1)), /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Previous")
    ), /*#__PURE__*/
    _jsx("span", {}, void 0, ` ${page} / ${totalPages} `), /*#__PURE__*/
    React.createElement(CurrentLocationLink, _extends({
      queryParams: { page: nextPage },
      onClick: (e) => {
        e.preventDefault();
        onPageChange(nextPage);
      } },
    disableButton(page, totalPages)), /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Next")
    )
    ));

};

Paginator.defaultProps = {
  page: 1,
  totalPages: 1,
  onPageChange: () => {}
};







// eslint-disable-next-line react/no-multi-comp
const PaginatorWithPage = (props) => {
  const [searchParams] = useSearchParams();
  const query = searchParamsFromSearchParams(searchParams);
  const restProps = _extends({}, (_objectDestructuringEmpty(props), props));
  return /*#__PURE__*/React.createElement(Paginator, _extends({}, restProps, { page: Number(query.page || 1) }));
};

export { PaginatorWithPage };